import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appDisableMultipleClickWithNoneEvent]',
    standalone: false
})
export class DisableMultipleClickWithNoneEventDirective {

  @Input() appDisableMultipleClickWithNoneEvent: number;

  constructor(
    private readonly elementRef: ElementRef,
    private readonly renderer: Renderer2
  ) {
  }

  @HostListener('click', ['$event'])
  click(_: MouseEvent) {
    this.renderer.addClass(this.elementRef.nativeElement, 'pointer-events-none');
    this.renderer.addClass(this.elementRef.nativeElement, 'opacity-6');
    setTimeout(() => {
      this.renderer.removeClass(this.elementRef.nativeElement, 'pointer-events-none');
      this.renderer.removeClass(this.elementRef.nativeElement, 'opacity-6');
    }, this.appDisableMultipleClickWithNoneEvent || 1000);
  }

}
